<template>
  <header class="header" role="banner">
    <div class="logo">
      <router-link to="/" @click="handleHomeClick">
        <div style="display: flex; align-items: center">
          <img src="@/assets/logo.png" :alt="$t('header.appName')" class="logo-img mr-3" />
          <h1 class="app-name" style="font-size: 1.3rem">{{ $t("header.appName") }}</h1>
        </div>
      </router-link>
    </div>
    <nav class="nav" role="navigation" aria-label="主导航">
      <a href="/doc/docs" class="nav-link">{{ $t("header.docs") }}</a>
      <router-link to="/image2-generate" class="nav-link">AI绘图</router-link>
      <router-link to="/square" class="nav-link">{{ $t("header.square") }}</router-link>

      <template v-if="!isLoggedIn">
        <router-link to="/login" class="login-btn">{{ $t("header.login") }}</router-link>
      </template>
      <template v-else>
        <div class="user-menu" ref="userMenu">
          <button @click="toggleUserDropdown" class="user-btn" :aria-label="$t('header.userMenu')">
            <i class="fas fa-user"></i>
          </button>
          <div class="user-dropdown" v-show="isUserDropdownOpen">
            <router-link to="/account" class="dropdown-item">
              <i class="fas fa-user-circle"></i>
              {{ $t("header.myAccount") }}
            </router-link>
            <button @click="handleLogout" class="dropdown-item">
              <i class="fas fa-sign-out-alt"></i>
              {{ $t("header.logout") }}
            </button>
          </div>
        </div>
      </template>
    </nav>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { logout } from "@/api/auth";

export default {
  name: "AppHeader",
  setup() {
    const router = useRouter();
    const { t, locale } = useI18n();
    const isUserDropdownOpen = ref(false);

    const toggleUserDropdown = () => {
      isUserDropdownOpen.value = !isUserDropdownOpen.value;
    };

    const closeUserDropdown = (event) => {
      const userMenu = document.querySelector(".user-menu");
      if (userMenu && !userMenu.contains(event.target)) {
        isUserDropdownOpen.value = false;
      }
    };

    const handleLogout = async () => {
      try {
        await logout();
        router.push("/login");
      } catch (error) {
        console.error("Logout failed", error);
      }
    };

    const initializeLanguage = () => {
      locale.value = "zh";
      localStorage.setItem("user-language", "zh");
    };

    const handleClickOutside = (event) => {
      closeUserDropdown(event);
    };

    const handleHomeClick = () => {
      window.dispatchEvent(new CustomEvent("app:go-home"));
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
      initializeLanguage();
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    return {
      isUserDropdownOpen,
      isLoggedIn: computed(() => !!localStorage.getItem("access_token")),
      toggleUserDropdown,
      closeUserDropdown,
      handleLogout,
      initializeLanguage,
      handleClickOutside,
      handleHomeClick,
      t,
    };
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-img {
  height: 40px;
}

.nav {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.nav a {
  color: #64748b;
  text-decoration: none;
  transition: color 0.3s ease;
}

.nav a:hover {
  color: #3b82f6;
}

.login-btn,
.logout-btn {
  color: #64748b;
  text-decoration: none;
  transition: color 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.login-btn:hover,
.logout-btn:hover {
  color: #3b82f6;
}

.user-menu {
  position: relative;
}

.user-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  color: #64748b;
  transition: color 0.3s ease;
}

.user-btn:hover {
  color: #3b82f6;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  color: #64748b;
  text-decoration: none;
  transition: background-color 0.2s;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}

.dropdown-item:hover {
  background-color: #f7fafc;
  color: #3b82f6;
}

.dropdown-item i {
  width: 1rem;
}

@media (max-width: 768px) {
  .nav {
    gap: 1rem;
  }

  .header {
    padding: 0.75rem 1rem;
  }

  .logo-img {
    height: 32px;
  }
}

@media (max-width: 480px) {
  .nav {
    gap: 0.5rem;
  }
}
</style>
